module.exports = __webpack_public_path__ + "static/media/0_2018_12_25.bd2f3405.jpg";